import { getMsalClient } from './client';
export var getAccount = function () {
    var currentAccounts = getMsalClient()
        .getAllAccounts();
    return currentAccounts === null || currentAccounts === void 0 ? void 0 : currentAccounts[0];
};
